export default __webpack_public_path__ + "static/media/card3-edp.33a0fedc.png";